import { JWT_OPTIONS, JwtConfig } from '@auth0/angular-jwt';
import settings from './settings.json';
import { StorageService } from '../services/storageService.service';
import { AUTH0_WHITE_LIST } from './auth0-variables';

export const jwtOptionsProvider = {
  provide: JWT_OPTIONS,
  useFactory: (storage: StorageService): JwtConfig => ({
    tokenGetter: (req) => {
      //Checks for no x-atc-no-auth header which will remove the default Authentication JWT bearer token header
      const hasHeader = req.headers.has('x-atc-no-auth');
      if (hasHeader) req.headers.delete('x-atc-no-auth');
      return hasHeader ? null : _evaluateToken(storage.get.token(), req.url);
    },
    allowedDomains: AUTH0_WHITE_LIST,
  }),
  deps: [StorageService],
};

/**
 * Evaluates the url for the reques and if acceptable the token is returned, if not null.
 */
function _evaluateToken(token: string, url: string): string | null {
  if (
    url.indexOf('openair') !== -1 ||
    url.includes('everymundo.io') ||
    url.includes(settings.GLOBAL_SETTINGS.frontComponentApi) ||
    url.includes(settings.GLOBAL_SETTINGS.frontComponentProdApi) ||
    url.includes(settings.GLOBAL_SETTINGS.fcServicesApiDev) ||
    url.includes(settings.GLOBAL_SETTINGS.fcServicesApiProd) ||
    url.includes('/core-dictionary-service') ||
    url.includes('airsem-api-dev.everymundo.io') ||
    url.includes('airsem-api.everymundo.io') ||
    //AWS Lambdas
    //DEV & PROD
    url.indexOf('zaqs4618c1') !== -1 ||
    url.indexOf('znsp7hqhcb') !== -1 ||
    url.indexOf('sf0v0hmwo5') !== -1 ||
    url.indexOf('r78g8omdc3') !== -1 ||
    url.indexOf('sschvg2irg') !== -1 ||
    url.indexOf('dmz23b0ksb') !== -1 ||
    url.indexOf('26kxr3hz31') !== -1 ||
    url.indexOf('tlquam98ad') !== -1 ||
    url.indexOf('rrwlq4zp75') !== -1 ||
    url.indexOf('j31tg7vwl4') !== -1 ||
    url.indexOf('vocqiv2qf5') !== -1 ||
    url.indexOf('x9dvfwgdtl') !== -1 ||
    url.indexOf('ggb3biask6') !== -1 ||
    url.indexOf('iui8cfqgtk') !== -1 ||
    url.indexOf('f4mofdbcm6') !== -1 ||
    url.indexOf('d7sijkop8c') !== -1
  ) {
    return token ? token : 'no token';
  } else {
    return null;
  }
}
